import { createFileRoute } from '@tanstack/react-router'
import { UserPreferencesView } from '@workspace/seedforge-ui/user-preferences'
import { FounderLayout } from '../../../../components/founder-layout'
import { useStartupContext } from '../../../../contexts/startup-guard'
import { useUpdateUserMutation } from '../../../../hooks/api'

export const Route = createFileRoute('/app/startup/$id/preferences')({
  component: FounderPreferencesPage,
})

function FounderPreferencesPage() {
  const { user } = useStartupContext()
  const updateUser = useUpdateUserMutation()

  return (
    <FounderLayout activeNav="">
      <UserPreferencesView
        preferences={{ emailSubscribed: user.emailSubscribed }}
        onEmailSubscribedChange={(value) => updateUser.mutate({ body: { emailSubscribed: value } })}
      />
    </FounderLayout>
  )
}
